module.exports = __webpack_public_path__ + "static/media/house5lg.2d238e60.png";